<template>
    <div v-show="statusLoadingRoute == false" class="bg-gray-100 lg:mt-12" ref="targetElement">
        <downloadPDF/>
    </div>
</template>

<script>
    import downloadPDF from '../components/downloadPDF.vue'
    import { mapState } from "vuex";
    export default {
        name: 'PdfView',
        components: {
            downloadPDF
        },
        computed: {
            ...mapState(['scrollHandler', 'statusLoadingRoute']),
        },
        mounted() {
            if (window.innerWidth < 1024) {
                this.$nextTick(() => {
                    if (this.scrollHandler) {
                        this.$refs.targetElement.scrollIntoView({ behavior: 'smooth', block: "start" });
                    }
                this.addScrollHandler(false)
                });            
            }
        },
    }

</script>